export default class Voucher
{
  constructor(titles, descriptions, categories, images, tax, price, highlighted) 
  {
    this.titles = titles; // {} instead of array to support stringify
    this.descriptions = descriptions; // {} instead of array to support stringify
    this.categories = categories;
    this.images = images;
    this.tax = tax;
    this.price = price;
    this.highlighted = highlighted;
  }    

  isValid()
  {
    var result = true;

    // Multilanguage fields
    for (const [key, value] of Object.entries(this.titles)) {
      if(!value)
      {
        result = false;
        break;
      };
    }

    for (const [key, value] of Object.entries(this.descriptions)) {
      if(!value)
      {
        result = false;
        break;
      };
    }

    // 
    if(result)
    {
      result = this.categories && this.categories.length && this.images && this.images.length && this.tax && this.price;
    }

    return result;
  }
}